import React from 'react';
import { connect } from 'react-redux';
import { provideLocalizationService, registerForLocalization } from '@progress/kendo-react-intl';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Button } from '@progress/kendo-react-buttons';
import { Grid } from '../../shared/components';
import { Colors, Text } from '../../../ui';
import { toggleUserMergeConfirmDialog, mergeUsers } from '../actions/user-duplicate-list-actions';
import { withRouter } from '../../../components/withRouter';

class UserDuplicateList extends React.Component {
  constructor(props) {
    super(props);
    this.handleMergeClick = this.handleMergeClick.bind(this);
    this.renderCellDiff = this.renderCellDiff.bind(this);
  }

  render() {
    const { user, userDuplicates, loading, isConfirmDialogVisible } = this.props;
    const localizationService = provideLocalizationService(this);
    return (
      <>
        <Grid
          loading={loading}
          data={userDuplicates}
          isPageable={false}
          columns={[
            {
              field: 'name',
              className: 'align-left',
              headerClassName: 'align-left',
              title: localizationService.toLanguageString('User.firstName'),
              cell: e => this.renderCellDiff({ e, cellValue: e.dataItem.name, valueToCompareAgainst: user.name })
            }, {
              field: 'surname',
              className: 'align-left',
              headerClassName: 'align-left',
              title: localizationService.toLanguageString('User.lastName'),
              cell: e => this.renderCellDiff({ e, cellValue: e.dataItem.surname, valueToCompareAgainst: user.surname })
            }, {
              field: 'personalCode',
              className: 'align-left',
              headerClassName: 'align-left',
              title: localizationService.toLanguageString('User.personalCode'),
              cell: e => this.renderCellDiff({ e, cellValue: e.dataItem.personalCode, valueToCompareAgainst: user.personalCode })
            }, {
              field: 'stampNumber',
              className: 'align-left',
              headerClassName: 'align-left',
              title: localizationService.toLanguageString('User.stampNumber'),
              cell: e => this.renderCellDiff({ e, cellValue: e.dataItem.stampNumber, valueToCompareAgainst: user.stampNumber })
            }, {
              field: 'key',
              className: 'align-left',
              headerClassName: 'align-left',
              title: localizationService.toLanguageString('User.key'),
              cell: e => this.renderCellDiff({ e, cellValue: e.dataItem.key, valueToCompareAgainst: user.key })
            }
          ]}
          actions={[
            { icon: 'replace-single', onClick: this.handleMergeClick }
          ]}
        />
        {isConfirmDialogVisible &&
          <Dialog title={localizationService.toLanguageString('custom.confirm')} onClose={this.props.toggleUserMergeConfirmDialog}>
            <Text>{localizationService.toLanguageString('User.userDuplicateDialogMessage')}</Text>
            <DialogActionsBar>
              <Button themeColor={'primary'} onClick={() => this.props.mergeUsers({ userId: user.id, userDuplicates })}>{localizationService.toLanguageString('buttons.merge')}</Button>
              <Button onClick={this.props.toggleUserMergeConfirmDialog}>{localizationService.toLanguageString('buttons.cancel')}</Button>
            </DialogActionsBar>
          </Dialog>
        }
      </>
    );
  }

  renderCellDiff({ e, cellValue = '', valueToCompareAgainst = '' }) {
    const localizationService = provideLocalizationService(this);
    return (
      <td className={e.className} onClick={() => this.handleRowClick(e)}>
        <Text variant={`body2`} textColor={cellValue === valueToCompareAgainst ? Colors.SUCCESS_50 : Colors.ERROR_40}>
          {cellValue || localizationService.toLanguageString('common.notDefined')}
        </Text>
      </td>
    );
  }

  handleMergeClick(e) {
    this.props.toggleUserMergeConfirmDialog(e.dataItem);
  }
}

const mapStateToProps = (state) => ({
  isConfirmDialogVisible: state.userDuplicateList.isConfirmDialogVisible,
  loading: state.userDuplicateList.loading
});

const mapDispatchToProps = (dispatch) => ({
  toggleUserMergeConfirmDialog: (payload) => dispatch(toggleUserMergeConfirmDialog(payload)),
  mergeUsers: (payload) => dispatch(mergeUsers(payload))
});

registerForLocalization(UserDuplicateList);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(UserDuplicateList));
